import { render, staticRenderFns } from "./SupportChatWidget.vue?vue&type=template&id=99977786&scoped=true"
import script from "./SupportChatWidget.vue?vue&type=script&lang=js"
export * from "./SupportChatWidget.vue?vue&type=script&lang=js"
import style0 from "./SupportChatWidget.vue?vue&type=style&index=0&id=99977786&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99977786",
  null
  
)

export default component.exports